import { render } from "./SettingView.vue?vue&type=template&id=4ece6b78&scoped=true"
import script from "./SettingView.vue?vue&type=script&lang=js"
export * from "./SettingView.vue?vue&type=script&lang=js"

import "./SettingView.vue?vue&type=style&index=0&id=4ece6b78&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ece6b78"]])

export default __exports__